import React from 'react'

import { Col } from '../../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../../packages/kiti/components/form/form/FormHandler'
import FormItem from '../../../../../packages/kiti/components/form/form/FormItem'
import LevelsLoader, { useLevels } from './_load/LevelsLoader'
import PlaceLevelSelect from '../../../../../containers/placeLevels/select/PlaceLevelSelect'

const PlaceLevelsInputs = () => {
  const form = useForm()
  const { handleChangeIn } = useFormState()
  const levels = useLevels()

  const formatFieldName = levelId => {
    if (levelId === null || levelId === undefined) {
      return false
    }
    return `placeLevel${levelId}`
  }

  const handleAfterChange = (_value, field) => {
    const { field: fieldName } = field
    const changedLevel = levels.find(level => formatFieldName(level.id) === fieldName)
    if (!changedLevel) {
      return
    }

    const filteredLevels = levels.filter((_level, index) => {
      return index !== 0 && index !== levels.length - 1
    })

    if (changedLevel.id === levels[0].id) {
      filteredLevels.forEach(level => handleChangeIn([formatFieldName(level.id)], null))
      return
    }

    if (changedLevel.id === levels[1].id) {
      filteredLevels.shift()
      filteredLevels.forEach(level => handleChangeIn([formatFieldName(level.id)], null))
      return
    }
  }

  return levels.map((level, index) => {
    const isName = index === levels.length - 1
    const parentLevel = levels[index - 1]
    const parentPlaceLevelId = form[formatFieldName(parentLevel?.id)]?.id
    const disabled = index > 0 && !isName && !parentPlaceLevelId
    const field = isName ? 'name' : formatFieldName(level.id)

    return (
      <Col width="50%" width_sm="100%" key={level.id}>
        <FormItem
          afterChange={handleAfterChange}
          label={level.name}
          field={field}
          Input={!isName && PlaceLevelSelect}
          disabled={disabled}
          parentIds={parentPlaceLevelId}
          types={form.type}
          levelIds={level.id}
        />
      </Col>
    )
  })
}

const Wrapper = () => {
  const form = useForm()

  return (
    <LevelsLoader type={form.type}>
      <PlaceLevelsInputs />
    </LevelsLoader>
  )
}

export default Wrapper
